<script>
import Paper from "@/components/Papers.vue";
import Seminar from "@/components/Seminar.vue";
export default {
    components:{
        Paper,
        Seminar
    }

}
</script>

<template>
    <div class="main container">
        <router-link to="/papers" class="link">期刊論文</router-link>
        <router-link to="/seminar" class="link">研討會論文</router-link>
    </div>
     <router-view/>
</template>


<style lang="scss" scoped>
    .main{
        width: 30%;
        height: 6%;
        margin-top: 2%;
        margin-bottom: 2%;
        border-radius:10px;
        text-align:center;
        align-content: center;
        background-color:gray;  
        >.link{
            color:#fff ;
            padding: 2%;
            font-size: 30px;  
        }
        
    }
</style>